// extracted by mini-css-extract-plugin
export default {"shutterstockFee":"FooterBlock_shutterstockFee__eMOgq","termsOfService":"FooterBlock_termsOfService__NoXaB"};